export const params = window.location.pathname.split('/');
export const moduleName = params[1] || 'main';
export const type = params[2];
export const name = params[3];
export const githubURL = window.pages.github[moduleName];
export const readme = window.pages.readme[moduleName];
export const root = window.pages.root[moduleName];
export const moduleNames = Object.keys(window.pages.readme);

export function getDocumentation() {
    let docs = window.pages.docs[moduleName][type][name];
    if (docs) docs.name = name;
    return docs;
}